import { useEffect } from "react";
import Logo from "../assets/images/logo.png"
const wrapperStyles = {
  position: "fixed",
  inset: 0,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  background: "#ffffff",
  zIndex: 99999,
  gap: "24px",
};

const logoStyles = {
  fontSize: "2.2rem",
  fontWeight: "700",
  letterSpacing: "2px",
  color: "#6d40e2",
  fontFamily: "'Arial Black', Arial, sans-serif",
};

const purpleText = {
  color: "#7b2cf7",
};

const spinnerStyles = {
  width: 56,
  height: 56,
  borderRadius: "50%",
  border: "6px solid rgba(0,0,0,0.08)",
  borderTopColor: "#7b2cf7",
  animation: "spin 1s linear infinite",
};
const loderlogo={
      
        width: "190px",
    height: "65px"
}

const Loader = ({ visible }) => {
  useEffect(() => {
    if (!document.getElementById("loader-keyframes")) {
      const style = document.createElement("style");
      style.id = "loader-keyframes";
      style.innerHTML = `@keyframes spin { to { transform: rotate(360deg); } }`;
      document.head.appendChild(style);
    }
  }, []);

  if (!visible) return null;

  return (
    <div style={wrapperStyles}>
      <div style={logoStyles}>
        <img src={Logo} alt="" style={loderlogo}/>
      </div>
      <div style={spinnerStyles} aria-hidden="true" />
    </div>
  );
};

export default Loader;